import { render, staticRenderFns } from "./ExchangeCurrency.vue?vue&type=template&id=2aa0593e&scoped=true&"
import script from "./ExchangeCurrency.vue?vue&type=script&lang=js&"
export * from "./ExchangeCurrency.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCurrency.vue?vue&type=style&index=0&id=2aa0593e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0593e",
  null
  
)

export default component.exports